import * as React from "react";

import useLogAnalyticsOnFirebaseAuthChange from "services/firebase/auth/analytics/useLogAnalyticsOnFirebaseAuthChange";
import useAuthWithCredentialsiOS from "services/firebase/ios/useAuthWithCredentials";

import useRedirectOnAuthStateChanged from "features/app/redirect-on-auth-state-changed/useRedirectOnAuthStateChanged";
import { HideableSplashScreen } from "features/common/loadingScreens/components/SplashScreen";
import { useHasUserSignedUpBefore, useResumeSession } from "features/user";

type Props = {
  initialized: boolean;
  children: React.ReactElement;
};

export default function ResumeSession({ initialized, children }: Props) {
  useAuthWithCredentialsiOS();

  useLogAnalyticsOnFirebaseAuthChange();

  const signInAttemptFinished = useResumeSession(initialized);
  const checkedIfSignedUpBefore = useHasUserSignedUpBefore();

  useRedirectOnAuthStateChanged();

  if (signInAttemptFinished && checkedIfSignedUpBefore) {
    return children;
  } else {
    return <HideableSplashScreen hide={signInAttemptFinished} />;
  }
}
